<template>
  <nav>
    <router-link to="/" id="logoNav">
      <img alt="Vue logo" src="../assets/logo.png" />
    </router-link>
    <router-link to="/games" class="button">GAMES</router-link>
    <router-link to="/worlds" class="button">WORLDS</router-link>
    <router-link to="/login" class="button">LOGIN</router-link>
  </nav>
  <hr />
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
export default class Header extends Vue {}
</script>

<style scope>

nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

#logoNav img {
  filter: invert();
  aspect-ratio: auto;
  width: 250px;
}
@media (min-width: 890px) {
  #logoNav img {
    width: 300px;
  }
}

.button {
  background: transparent;
  padding: 1.0rem 1.6rem;
  font-size: 1rem;

  border-top-left-radius: 255px 15px;
  border-top-right-radius: 15px 225px;
  border-bottom-right-radius: 225px 15px;
  border-bottom-left-radius: 15px 255px;

  border:solid 2px #e2dfda;
  align-self: center;
}

.button:hover {
  border-color: #fff;
}
hr {
  width: 92vw;
}

</style>
